// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__22JMU","colCheckbox":"styles_colCheckbox__1ESZo"};